import { jsPDF } from "jspdf";
import { displayText } from "./displayText";

// The same locally hosted, openly licensed typefaces used by the interface.
let pdfFonts;
const loadFonts = () => {
  if (!pdfFonts) pdfFonts = Promise.all(["geist", "geist-medium", "geist-semibold"].map(async (name) => {
    const response = await fetch(`/fonts/${name}.ttf`);
    const bytes = new Uint8Array(await response.arrayBuffer());
    let binary = "";
    for (let i = 0; i < bytes.length; i += 8192) binary += String.fromCharCode(...bytes.subarray(i, i + 8192));
    return [name, btoa(binary)];
  }));
  return pdfFonts;
};

export async function generatePDF(b) {
  const fonts = await loadFonts();
  const doc = new jsPDF({ unit: "mm", format: "a4" });
  fonts.forEach(([name, data]) => {
    doc.addFileToVFS(`${name}.ttf`, data);
    doc.addFont(`${name}.ttf`, name, "normal");
  });
  const W = 210;
  const H = 297;
  const M = 20;
  const ink = [244, 241, 250];
  const secondary = [165, 157, 184];
  const accent = [124, 58, 237];
  let y = 0;

  const bg = () => {
    doc.setFillColor(11, 6, 22);
    doc.rect(0, 0, W, H, "F");
    doc.setDrawColor(42, 33, 64);
    doc.setLineWidth(0.25);
    doc.line(M, 18, W - M, 18);
  };
  bg();

  const newPageIfNeeded = (needed) => {
    if (y + needed > H - 25) {
      doc.addPage();
      bg();
      y = 30;
    }
  };

  doc.setTextColor(...ink);
  doc.setFont("geist-semibold", "normal");
  doc.setFontSize(24);
  doc.text("ide", M, 36);
  const logoWidth = doc.getTextWidth("ide");
  doc.setFont("geist-semibold", "normal");
  doc.setTextColor(...accent);
  doc.text("vorai", M + logoWidth, 36);
  doc.setFont("geist-medium", "normal");
  doc.setFontSize(8);
  doc.setTextColor(...secondary);
  doc.text("TON BUSINESS / TON PLAN DE 30 JOURS", M, 47);
  y = 65;

  const heading = (t) => {
    newPageIfNeeded(30);
    y += 7;
    doc.setDrawColor(42, 33, 64);
    doc.line(M, y, W - M, y);
    y += 10;
    doc.setTextColor(...accent);
    doc.setFont("geist-semibold", "normal");
    doc.setFontSize(20);
    doc.text(t, M, y);
    y += 10;
  };

  const para = (t, color = secondary) => {
    doc.setTextColor(...color);
    doc.setFont("geist", "normal");
    doc.setFontSize(10);
    const lines = doc.splitTextToSize(displayText(t), W - 2 * M);
    lines.forEach((ln) => {
      newPageIfNeeded(6);
      doc.text(ln, M, y);
      y += 5.5;
    });
    y += 3;
  };

  doc.setTextColor(...ink);
  doc.setFont("geist-semibold", "normal");
  doc.setFontSize(28);
  const title = doc.splitTextToSize(displayText(b.business_name || "Ton business"), W - 2 * M);
  title.forEach((line) => { newPageIfNeeded(12); doc.text(line, M, y); y += 11; });
  y += 2;
  doc.setFont("geist-medium", "normal");
  doc.setFontSize(8);
  doc.setTextColor(...accent);
  doc.text(b.type === "physique" ? "BUSINESS PHYSIQUE" : "BUSINESS EN LIGNE", M, y);
  y += 10;
  para(b.pitch);

  heading("01 — Pourquoi toi");
  (b.why_you || []).forEach((r) => para("— " + r));
  heading("02 — Client cible");
  para(b.target_client);
  heading("03 — Prix & potentiel");
  para(`Prix : ${b.pricing}`);
  para(`Coût de départ : ${b.startup_cost}`);
  para(`Potentiel 1er mois : ${b.first_month_potential}`);
  heading("04 — Outils à utiliser");
  para((b.tools || []).join(" · "));
  heading("05 — Plan de 30 jours");
  (b.plan_30_days || []).forEach((d) => {
    doc.setFont("geist-semibold", "normal");
    doc.setFontSize(12);
    const lines = doc.splitTextToSize(displayText(`Jour ${d.day} — ${d.title}`), W - 2 * M);
    newPageIfNeeded(lines.length * 6 + 14);
    doc.setTextColor(...ink);
    lines.forEach((line) => { doc.text(line, M, y); y += 6; });
    y += 2;
    (d.tasks || []).forEach((t) => para("— " + t));
    y += 3;
  });
  heading("06 — Script pour ton 1er client");
  para(b.first_client_script);
  heading("07 — Risques & solutions");
  (b.risks_and_solutions || []).forEach((r) => {
    para(`Risque : ${r.risk}`);
    para(`Solution : ${r.solution}`, accent);
  });

  const pages = doc.getNumberOfPages();
  for (let page = 1; page <= pages; page++) {
    doc.setPage(page);
    doc.setDrawColor(42, 33, 64);
    doc.line(M, H - 18, W - M, H - 18);
    doc.setFont("geist-medium", "normal");
    doc.setFontSize(7);
    doc.setTextColor(...secondary);
    doc.text("IDEVORAI / DE L'IDÉE À L'ACTION", M, H - 11);
    doc.text(`${String(page).padStart(2, "0")} / ${String(pages).padStart(2, "0")}`, W - M, H - 11, { align: "right" });
  }
  doc.save(`idealab-${displayText(b.business_name || "business").replace(/\s+/g, "-").toLowerCase()}.pdf`);
}
